/* HUENIT LAB 2.0 — Admin 진입점. ReactDOM root + 전역 Provider 배선.
   SessionProvider(인증) → ToastProvider(토스트) → App(셸·게이트). */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/admin.css';
import { SessionProvider } from './auth/session.jsx';
import { ToastProvider } from './components/Toast.jsx';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SessionProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </SessionProvider>
  </StrictMode>
);
